import { z } from 'zod';
import { emailSchema, idSchema, isoDateSchema, pseudoSchema } from './common';
import { memberRoleSchema, memberStatusSchema } from '../enums';
/** Écran 00 — « Recevoir mon lien ». Réponse toujours 202, même si l'email est inconnu. */
export const requestMagicLinkSchema = z.object({
    email: emailSchema,
});
/**
 * Politique de mot de passe — fondée sur la longueur, pas sur la composition.
 *
 * Exiger une majuscule, un chiffre et un caractère spécial produit surtout des
 * « Cercle2026! » : courts, prévisibles, et notés sur un papier. Douze caractères libres
 * valent mieux, et c'est la recommandation de l'ANSSI comme du NIST.
 *
 * La règle complète (mots trop devinables) vit côté API ; ce schéma en applique la part
 * mécanique pour que le front puisse prévenir sans aller-retour.
 */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 200;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Le mot de passe doit faire au moins ${PASSWORD_MIN_LENGTH} caractères.`)
    .max(PASSWORD_MAX_LENGTH, `Le mot de passe ne peut pas dépasser ${PASSWORD_MAX_LENGTH} caractères.`);
/** Écran 00 — connexion par email et mot de passe. */
export const signInSchema = z.object({
    email: emailSchema,
    // Pas de contrainte de longueur à la connexion : un mot de passe créé sous une politique
    // antérieure doit rester utilisable, et la borne ne renseignerait qu'un attaquant.
    password: z.string().min(1, 'Mot de passe requis.').max(PASSWORD_MAX_LENGTH),
});
/** Écran Profil — changement de mot de passe par le membre lui-même. */
export const changePasswordSchema = z.object({
    currentPassword: z.string().max(PASSWORD_MAX_LENGTH).optional(),
    newPassword: passwordSchema,
});
/** Validation du lien reçu par email : pose les cookies et renvoie le membre. */
export const consumeMagicLinkSchema = z.object({
    token: z.string().min(16),
});
/** Écran 00 bis — le lien d'invitation est ouvert, le membre choisit pseudo et avatar. */
export const acceptInvitationSchema = z.object({
    token: z.string().min(16),
    pseudo: pseudoSchema,
    password: passwordSchema,
    avatarUrl: z.url().max(2048).nullish(),
});
/** Vérification « disponible » affichée en direct sous le champ pseudo. */
export const checkPseudoSchema = z.object({
    pseudo: pseudoSchema,
});
export const authenticatedMemberSchema = z.object({
    id: idSchema,
    email: emailSchema,
    pseudo: pseudoSchema,
    avatarUrl: z.string().nullable(),
    role: memberRoleSchema,
    status: memberStatusSchema,
    createdAt: isoDateSchema,
});
//# sourceMappingURL=auth.js.map